import React from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "../data/blogPosts";
import "../styles/Blog.css"; // Importieren Sie Ihre CSS-Datei für Blog
const Blog = () => {
  return (
    <div className="container">
      <div className="blog-content">
        <h1>Fitness Blog</h1>
        <div className="blog-posts-grid">
          {blogPosts.map((post) => (
            <article key={post.id} className="blog-post-card">
              <h2>{post.title}</h2>
              <div className="post-meta">
                <span className="post-date">{new Date(post.date).toLocaleDateString('de-DE')}</span>
                <span className="post-author">von {post.author}</span>
              </div>
              <p className="post-excerpt">{post.excerpt}</p>
              <Link to={`/blog/${post.id}`} className="read-more-link">
                Weiterlesen
              </Link>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;